import { Link } from 'react-router-dom';
import { EmptyState, assetUrl, money } from '../components/common';
import { lineTotal, useCart } from '../state/CartContext';

export function CartPage() {
  const { lines, subtotal, setQuantity, remove, clear } = useCart();

  if (lines.length === 0) {
    return (
      <EmptyState
        title="Your cart is empty"
        message="Pick something fresh off the menu and it will show up here."
        action={
          <Link to="/" className="btn btn--primary">
            Browse the menu
          </Link>
        }
      />
    );
  }

  return (
    <section className="page">
      <header className="page__head">
        <h1>Your cart</h1>
        <button type="button" className="btn btn--ghost btn--sm" onClick={clear}>
          Clear cart
        </button>
      </header>

      <ul className="cart">
        {lines.map((line) => (
          <li key={line.key} className="cart__line">
            {line.imageUrl && (
              <img src={assetUrl(line.imageUrl) ?? undefined} alt="" width={72} height={72} loading="lazy" />
            )}

            <div className="cart__info">
              <h3>
                {line.productName} <span className="muted">({line.variantLabel})</span>
              </h3>
              {/* Grouped and counted, so "Berry Blast x3" reads as one line
                  rather than three identical ones. */}
              {line.choices.length > 0 && (
                <p className="muted small">
                  {Object.entries(
                    line.choices.reduce<Record<string, number>>((acc, c) => {
                      acc[c.label] = (acc[c.label] ?? 0) + 1;
                      return acc;
                    }, {}),
                  )
                    .map(([label, n]) => (n > 1 ? `${label} ×${n}` : label))
                    .join(', ')}
                </p>
              )}
              {line.addOns.length > 0 && (
                <p className="muted small">+ {line.addOns.map((a) => a.name).join(', ')}</p>
              )}
              {line.notes && <p className="muted small italic">“{line.notes}”</p>}
            </div>

            <div className="qty qty--sm">
              <button type="button" onClick={() => setQuantity(line.key, line.quantity - 1)} aria-label="Fewer">
                −
              </button>
              <span>{line.quantity}</span>
              <button type="button" onClick={() => setQuantity(line.key, line.quantity + 1)} aria-label="More">
                +
              </button>
            </div>

            <strong className="cart__total">{money(lineTotal(line))}</strong>

            <button
              type="button"
              className="cart__remove"
              onClick={() => remove(line.key)}
              aria-label={`Remove ${line.productName}`}
            >
              ×
            </button>
          </li>
        ))}
      </ul>

      <div className="summary">
        <div className="summary__row">
          <span>Subtotal</span>
          <strong>{money(subtotal)}</strong>
        </div>
        <p className="muted small">Delivery is worked out at checkout, once you pick your suburb.</p>

        <Link to="/checkout" className="btn btn--primary btn--block">
          Checkout
        </Link>
        <Link to="/" className="btn btn--ghost btn--block">
          Add more
        </Link>
      </div>
    </section>
  );
}
